// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"304":"careers","462":"legal","544":"lang-fr","884":"admin","908":"lang-pt"}[chunkId] || chunkId) + "." + {"162":"76d8ca10","304":"a40a8d03","447":"b9d7b780","462":"bc9d9b36","544":"a5ef1078","669":"b4b9129b","828":"36d8f761","884":"815d3f54","908":"9cfb4e56"}[chunkId] + ".chunk.js";
};